module.exports = __webpack_public_path__ + "static/media/simplex.91d652fe.svg";